export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6201.ca08cd4a.jpg";